import {createPortError} from '../platform/port-error.js';
import {recipeSaveFromRow,recipeSaveToRow} from './recipe-save.js';

function required(value,label,max=160){
  const text=String(value??'').trim();
  if(!text)throw new TypeError(label+' is required');
  if(text.length>max)throw new TypeError(label+' is too long');
  return text;
}

function remoteFailure(code){
  return createPortError(code,{retryable:true});
}

export function createSupabaseRecipeSaveRemote({client,userId}={}){
  if(typeof client?.from!=='function')throw new TypeError('Database client with from() is required');
  const owner=required(userId,'userId',128);

  async function list(){
    const {data,error}=await client.from('recipe_saves')
      .select('*')
      .eq('user_id',owner);
    if(error)throw remoteFailure('RECIPE_SAVE_LIST_FAILED');
    return Object.freeze((data||[]).map(row=>Object.freeze({
      ...recipeSaveFromRow(row),
      serverVersion:Number(row.version)||1
    })));
  }

  async function upsert(entity){
    if(entity.userId!==owner)throw new TypeError('RECIPE_SAVE_OWNER_MISMATCH');
    const row=recipeSaveToRow(entity);
    const {data,error}=await client.from('recipe_saves')
      .upsert(row,{onConflict:'user_id,recipe_id'})
      .select('*')
      .single();
    if(error)throw remoteFailure('RECIPE_SAVE_UPSERT_FAILED');
    return Object.freeze({
      ...recipeSaveFromRow(data),
      serverVersion:Number(data?.version)||1
    });
  }

  async function remove(entity){
    if(entity.userId!==owner)throw new TypeError('RECIPE_SAVE_OWNER_MISMATCH');
    const {error}=await client.from('recipe_saves')
      .delete()
      .eq('user_id',owner)
      .eq('recipe_id',entity.recipeId);
    if(error)throw remoteFailure('RECIPE_SAVE_DELETE_FAILED');
    return Object.freeze({ok:true});
  }

  return Object.freeze({list,upsert,remove});
}
